import { render, staticRenderFns } from "./indicatorBall.vue?vue&type=template&id=48e90235"
import script from "./indicatorBall.vue?vue&type=script&lang=js"
export * from "./indicatorBall.vue?vue&type=script&lang=js"
import style0 from "./indicatorBall.vue?vue&type=style&index=0&id=48e90235&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports